module.exports = __webpack_public_path__ + "img/global.0c96322f.0c96322f.jpg";